import { useLocation, useNavigate } from 'react-router-dom';
import '../../asset/css/main.css';

export default function Sidebar({ navLinks, user, isJudge = false, isOpen, onClose }) {
  const location = useLocation();
  const navigate  = useNavigate();

  const go = (path) => { navigate(path); onClose(); };
  const logout = () => { navigate('/login'); onClose(); };

  return (
    <>
      {/* mobile overlay */}
      <div className={`sb-overlay${isOpen ? ' open' : ''}`} onClick={onClose} />

      <aside className={`sidebar${isOpen ? ' open' : ''}`}>
        {/* Logo */}
        <div className="sb-logo">
          <span className="sb-logo-icon">♪</span>
          <span className="sb-logo-text">SoundBattle</span>
        </div>

        {/* Nav */}
        <nav className="sb-nav">
          <span className="sb-section">Navigation</span>
          {navLinks.map(l => (
            <button
              key={l.path}
              className={`sb-link${location.pathname === l.path ? ' active' + (isJudge ? ' j' : '') : ''}`}
              onClick={() => go(l.path)}
            >
              <span className="sb-icon">{l.icon}</span>
              {l.label}
              {l.count && <span className="sb-badge">{l.count}</span>}
            </button>
          ))}
        </nav>

        {/* User footer */}
        <div className="sb-foot">
          <div className="sb-user">
            <img src={user.avatar} alt={user.name} className="sb-avatar" />
            <div>
              <div className="sb-uname">{user.name}</div>
              <div className="sb-urole">{isJudge ? 'Judge' : 'Contestant'}</div>
            </div>
            <button className="sb-logout" onClick={logout} title="Log out">⏻</button>
          </div>
        </div>
      </aside>
    </>
  );
}